export default __webpack_public_path__ + "static/media/product12.70bb1d60.png";